import styled from "styled-components";

export default styled.div`
  padding: 20px;
  overflow-y: auto;
  box-sizing: border-box;

  @media (max-width: 768px) {
    max-height: ${props => (props.size ? props.size : "70vh")};
  }
`;



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/CustomDialog/DialogBody.js